import { VideoMetadata } from '../metadata/video-metadata.model';

export class VideoLink {
  public url: string;
  public meta: VideoMetadata;

  constructor(data: any = {}) {
    this.url = data?.url ?? '';
    this.meta = data?.meta ?? {};
  }

  public static createFromApi(data: any = {}): VideoLink {
    const meta = VideoMetadata.createFromApi(data?.meta ?? {});
    return new VideoLink({
      ...data,
      meta,
    });
  }

  public processForApi(): Record<string, any> {
    return {
      url: this.url,
      meta: this.meta.processForApi(),
    }
  }

}
